import clsx from "clsx";
import styles from "./styles/InstructorDashboardCard.module.css";

const InstructorDashboardCard = (props) => {
  const { image, title, values, addition } = props;
  return (
    <>
      <div className={styles.dashboardCard}>
        <div className={clsx(styles.dashboardCardLeft)}>
          <h5>{title}</h5>
          <h2>{values}</h2>
          {/* <span style={{ background: "#ffc136" }}>{addition}</span> */}
        </div>
        <div className={clsx(styles.dashboardCardRight)}>
          <img src={image} alt="" />
        </div>
      </div>
    </>
  );
};

export { InstructorDashboardCard };
